// src/context/ModalHeaderContext.js

import React, {
  createContext,
  useState,
  useCallback,
  useEffect,
  useContext
} from 'react';
import { ModalContext } from './ModalContext';
import { TabContext }   from './TabContext';      // ← importa TabContext

export const ModalHeaderContext = createContext({ /* ... */ });

export const ModalHeaderProvider = ({ children }) => {
  const { modalStacks } = useContext(ModalContext);   // sólo modalStacks
  const { activeTab }   = useContext(TabContext);     // activeTab viene de TabContext

  const [actionsMap, setActionsMap]     = useState({});
  const [disabledMap, setDisabledMap]   = useState({});

  // 1️⃣ Registrar callbacks para un modalId dado (sin tocar disabledMap aquí)
  const registerHeaderActions = useCallback((modalId, actions) => {
    setActionsMap(prev => ({
      ...prev,
      [modalId]: actions
    }));
  }, []);

  // 2️⃣ Quitar callbacks (y su disabledMap) al desmontar el modal
  const unregisterHeaderActions = useCallback((modalId) => {
    setActionsMap(prev => {
      const copy = { ...prev }; delete copy[modalId]; return copy;
    });
    setDisabledMap(prev => {
      const copy = { ...prev }; delete copy[modalId]; return copy;
    });
  }, []);

  // 3️⃣ Recuperar callbacks para un modalId
  const getHeaderActions = useCallback((modalId) => {
    return actionsMap[modalId] || null;
  }, [actionsMap]);

  // 4️⃣ Permite forzar/deshacer la deshabilitación manualmente
  const setHeaderDisabled = useCallback((modalId, isDisabled) => {
    setDisabledMap(prev => ({
      ...prev,
      [modalId]: isDisabled
    }));
  }, []);

  // ---- LOGGING y lógica para deshabilitar header padre ----
  useEffect(() => {
    const stack = modalStacks[activeTab] || [];
    if (stack.length >= 2) {
      // el padre es el penúltimo
      const parent = stack[stack.length - 2];
      // el hijo es el último
      const child  = stack[stack.length - 1];
      const disable = !!child.metadata?.disableHeader || !!child.disableHeader;
      setDisabledMap(prev => ({ ...prev, [parent.id]: disable }));
    } else {
      setDisabledMap({});
    }
  }, [modalStacks, activeTab]);

  return (
    <ModalHeaderContext.Provider value={{
      getHeaderActions,
      registerHeaderActions,
      unregisterHeaderActions,
      disabledMap,
      setHeaderDisabled
    }}>
      {children}
    </ModalHeaderContext.Provider>
  );
};
